import type { ComponentType } from "react";

type HOC<P extends object> = (component: ComponentType<P>) => ComponentType<P>;

export function composeHOCs<P extends object>(Component: ComponentType<P>, ...hocs: Array<HOC<P>>): ComponentType<P> {
    return hocs.reduce((acc, hoc) => {
        // If hoc is a HOC (normal function), call it directly
        return hoc(acc);
    }, Component);
}
